import { useState } from 'react';
import { faqs } from '@/mocks/homeContent';

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-100 py-14 md:py-20">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }} />
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-bold uppercase tracking-widest text-primary-600">FAQ</span>
          <h2 className="mt-1 font-heading text-3xl text-foreground-950 md:text-4xl">常见问题</h2>
          <p className="mt-2 text-sm text-foreground-700">关于投稿、审核与社区规范，这里都能找到答案。</p>
        </div>

        <div className="mx-auto mt-8 max-w-3xl flex flex-col gap-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                  isOpen ? 'border-primary-300' : 'border-background-200'
                }`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full cursor-pointer items-center justify-between gap-3 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="text-sm font-semibold text-foreground-950 md:text-base">{f.q}</span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                    }`}
                  >
                    <i className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-lg`}></i>
                  </span>
                </button>
                {isOpen && (
                  <p className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-700">{f.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}